import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatDate'
})
export class CustomDatePipe extends DatePipe
{

    constructor(private translate: TranslateService)
    {
        super(translate.currentLang);
    }

    transform(value: any, format?: string, timezone?: string, locale?: string): any
    {
        return super.transform(value, format, timezone, this.translate.currentLang || locale);
    }
}
